"use client";

import { useEffect } from "react";
import { loadFacebookSdk } from "@/lib/meta/embedded-signup";

/**
 * Preloads the Facebook JS SDK as soon as the app mounts so the WhatsApp
 * Embedded Signup wizard doesn't pay the load cost on first click.
 * launchEmbeddedSignup() also calls loadFacebookSdk itself (idempotent),
 * so correctness never depends on this provider having run first.
 */
export function MetaSdkProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_META_APP_ID;
    if (appId) {
      loadFacebookSdk(appId, process.env.NEXT_PUBLIC_META_API_VERSION || "v23.0").catch(() => {});
    }
  }, []);

  return <>{children}</>;
}
